import React, { useState } from "react";
import { Card, CardContent, CardHeader, Divider, Grid, Stack } from "@mui/material";
import Notification from "../../components/Notification";
import CustomerPaymentToDeltaSettingsPanel from "./components/CustomerPaymentToDeltaSettingsPanel";

const CustomerSettings = ({ customerId }) => {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  return (
    <>
      <Notification notify={notify} setNotify={setNotify} />
      <Card sx={{ scrollbarGutter: "stable" }}>
        <CardHeader
          title="Customer Settings"
          titleTypographyProps={{ sx: { fontSize: "1.15rem", fontWeight: 700 } }}
          subheader="Configure customer-specific options and preferences."
          subheaderTypographyProps={{
            noWrap: true,
            sx: { overflow: "hidden", textOverflow: "ellipsis" },
          }}
          sx={{ minHeight: 72, pb: 1 }}
        />
        <Divider />
        <CardContent sx={{ pt: 5, pb: 2, px: 2, "&:last-child": { pb: 2 } }}>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Stack spacing={3}>
                <CustomerPaymentToDeltaSettingsPanel customerId={customerId} setNotify={setNotify} />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default CustomerSettings;
